// src/components/page-content-v4/contexts/PageFormContext.tsx
import React, { createContext, useContext } from 'react';
import { usePageForm } from '../hooks/usePageForm';
import { Template, PageData, AccountInfo } from '../types';

interface PageFormContextProps {
  template: Template | null;
  page: PageData | null;
  setPage: React.Dispatch<React.SetStateAction<PageData | null>>;
  isLoading: boolean;
  error: Error | null;
  savePage: (isDraft: boolean) => Promise<void>;
  isSeoEnabled: boolean;
  accountInfo: AccountInfo | null;
  isDraftEditing: boolean;
  handlePublishDraft: () => Promise<void>;
  reloadPageData: () => Promise<void>;
  discardDraft: () => Promise<void>;
}

const PageFormContext = createContext<PageFormContextProps | undefined>(undefined);

export const PageFormProvider: React.FC<{ children: React.ReactNode; templateId: string; pageId?: string; selectedLanguage: string; }> = ({ children, templateId, pageId, selectedLanguage }) => {
  const pageForm = usePageForm(templateId, pageId, selectedLanguage);

  return (
    <PageFormContext.Provider value={pageForm}>
      {children}
    </PageFormContext.Provider>
  );
};

export const usePageFormContext = () => {
  const context = useContext(PageFormContext);
  if (context === undefined) {
    throw new Error('usePageFormContext must be used within a PageFormProvider');
  }
  return context;
};
